import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FAQService } from "../../../services";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { handleConsoleError } from "../../../utils/common-methods";

const AdminFaqModel = {
  id: "",
  question: "",
  answer: "",
  isActive: false,
};

export default function CreateFaq() {
  const navigate = useNavigate();
  const { register, handleSubmit, reset, setValue } = useForm();
  const [faqData, setFaqData] = useState({ ...AdminFaqModel });

  useEffect(() => {
    getFAQById();
    register("isActive");
  }, []);

  const id = FAQService.getFaqId();

  // Get FAQ by ID
  const getFAQById = async () => {
    try {
      const res = (id && (await FAQService.getFAQById(id))) || [];
      const fetchedData = { ...AdminFaqModel, ...res?.data };
      reset(fetchedData);
      setFaqData(fetchedData);
    } catch (error) {
      const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  const onSubmit = async (data) => {
    try {
      let response = null;
      const faqFormData = {
        question: data?.question,
        answer: data?.answer,
        isActive: data?.isActive,
      };

      if (id) {
        faqFormData.id = id;
      }
      response = await FAQService.updateFAQ(faqFormData);

      if (response?.isSuccess) {
        toast.success(response?.message);
        FAQService.removeFaqId();
        navigate(routes.ADMIN_FAQ_LIST);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {      
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleIsActiveChange = (event) => {
    const newStatus = event.target.checked;
    setFaqData({ ...faqData, isActive: newStatus });
    setValue("isActive", newStatus);
  };

  return (
    <div className="container mt-5">
      <div className="card p-4 shadow-sm">
        <h2 className="mb-3">FAQ Management</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label>Question</label>
            <input
              type="text"
              className="form-control"
              {...register("question", { required: "Question is required" })}
              value={faqData?.question}
              onChange={(e) =>
                setFaqData({ ...faqData, question: e.target.value })
              }
            />
          </div>

          <div className="mb-3">
            <label>Answer</label>
            <input
              type="text"
              className="form-control"
              {...register("answer", { required: "Answer is required" })}
              value={faqData?.answer}
              onChange={(e) =>
                setFaqData({ ...faqData, answer: e.target.value })
              }
            />
          </div>

          <div className="mb-3">
            <label>Status</label>
            <Form.Check
              type="checkbox"
              checked={faqData?.isActive}
              onChange={handleIsActiveChange}
            />
          </div>

          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
